export default __webpack_public_path__ + "static/media/title.37c6c4be.png";